// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"7140970d","23":"7140970d","688":"1ffdf7f1"}[chunkId] + ".chunk.css";
};